import { PlayerColor } from '@colonist/game-states';
(function(GameColor) {
    (function(Color) {
        Color[Color["PrimaryBlue0"] = 0] = "PrimaryBlue0";
        Color[Color["PrimaryBlue1"] = 1] = "PrimaryBlue1";
        Color[Color["PrimaryBlue2"] = 2] = "PrimaryBlue2";
        Color[Color["PrimaryBlue3"] = 3] = "PrimaryBlue3";
        Color[Color["PrimaryBlue4"] = 4] = "PrimaryBlue4";
        Color[Color["PrimaryBlue5"] = 5] = "PrimaryBlue5";
        Color[Color["PrimaryBlue6"] = 6] = "PrimaryBlue6";
        Color[Color["PrimaryBlue7"] = 7] = "PrimaryBlue7";
        Color[Color["PrimaryBlue8"] = 8] = "PrimaryBlue8";
        Color[Color["PrimaryBlue9"] = 9] = "PrimaryBlue9";
        Color[Color["PrimaryOrange0"] = 10] = "PrimaryOrange0";
        Color[Color["Gray0"] = 11] = "Gray0";
        Color[Color["Gray1"] = 12] = "Gray1";
        Color[Color["Gray2"] = 13] = "Gray2";
        Color[Color["Gray3"] = 14] = "Gray3";
        Color[Color["Gray4"] = 15] = "Gray4";
        Color[Color["White"] = 16] = "White";
        Color[Color["PlayerGoldBgLight"] = 17] = "PlayerGoldBgLight";
        Color[Color["PlayerRedBgDark"] = 18] = "PlayerRedBgDark";
        Color[Color["PlayerBlueBgDark"] = 19] = "PlayerBlueBgDark";
        Color[Color["PlayerGreenBgDark"] = 20] = "PlayerGreenBgDark";
        Color[Color["PlayerOrangeBgDark"] = 21] = "PlayerOrangeBgDark";
        Color[Color["PlayerBlackBgDark"] = 22] = "PlayerBlackBgDark";
        Color[Color["PlayerBronzeBgDark"] = 23] = "PlayerBronzeBgDark";
        Color[Color["PlayerSilverBgDark"] = 24] = "PlayerSilverBgDark";
        Color[Color["PlayerGoldBgDark"] = 25] = "PlayerGoldBgDark";
        Color[Color["PlayerWhiteDark"] = 26] = "PlayerWhiteDark";
        Color[Color["PlayerPurpleDark"] = 27] = "PlayerPurpleDark";
        Color[Color["PlayerMyscticBlueDark"] = 28] = "PlayerMyscticBlueDark";
        Color[Color["PlayerPinkDark"] = 29] = "PlayerPinkDark";
        Color[Color["GreenLink"] = 30] = "GreenLink";
        Color[Color["GreenLight"] = 31] = "GreenLight";
        Color[Color["GreenDark"] = 32] = "GreenDark";
        Color[Color["GreenStatusCheckmark"] = 33] = "GreenStatusCheckmark";
        Color[Color["RedLight"] = 34] = "RedLight";
        Color[Color["RedDark"] = 35] = "RedDark";
        Color[Color["Sea"] = 36] = "Sea";
        Color[Color["DarkGrey"] = 37] = "DarkGrey";
        Color[Color["OffWhite"] = 38] = "OffWhite";
        Color[Color["GrayScale0"] = 39] = "GrayScale0";
        Color[Color["GrayScale1"] = 40] = "GrayScale1";
        Color[Color["GrayScale2"] = 41] = "GrayScale2";
        Color[Color["GrayScale3"] = 42] = "GrayScale3";
        Color[Color["GrayScale4"] = 43] = "GrayScale4";
        Color[Color["GrayScale5"] = 44] = "GrayScale5";
        Color[Color["GrayScale6"] = 45] = "GrayScale6";
        Color[Color["GrayScale7"] = 46] = "GrayScale7";
        Color[Color["GrayScale8"] = 47] = "GrayScale8";
        Color[Color["GrayScale9"] = 48] = "GrayScale9";
        Color[Color["GrayScale10"] = 49] = "GrayScale10";
        Color[Color["GrayScale11"] = 50] = "GrayScale11";
        Color[Color["GrayScale12"] = 51] = "GrayScale12";
        Color[Color["GrayScale13"] = 52] = "GrayScale13";
        Color[Color["GrayScale14"] = 53] = "GrayScale14";
        Color[Color["GrayScale15"] = 54] = "GrayScale15";
        Color[Color["GrayScale16"] = 55] = "GrayScale16";
        Color[Color["GrayScale17"] = 56] = "GrayScale17";
        Color[Color["GrayScale18"] = 57] = "GrayScale18";
        Color[Color["GrayScale19"] = 58] = "GrayScale19";
        Color[Color["GrayScale20"] = 59] = "GrayScale20";
        Color[Color["GrayScale21"] = 60] = "GrayScale21";
        Color[Color["GrayScale22"] = 61] = "GrayScale22";
        Color[Color["GrayScale23"] = 62] = "GrayScale23";
        Color[Color["GrayScale24"] = 63] = "GrayScale24";
        Color[Color["GrayScale25"] = 64] = "GrayScale25";
        Color[Color["CardViewFadedTint"] = 65] = "CardViewFadedTint";
    })(GameColor.Color || (GameColor.Color = {}));
    function getColor(color) {
        switch(color){
            case 0:
                return '#328DC0';
            case 1:
                return '#c2e6f2';
            case 2:
                return '#5cc3e5';
            case 3:
                return '#2a748c';
            case 4:
                return '#263940';
            case 5:
                return '#177FDE';
            case 6:
                return '#1B446A';
            case 7:
                return '#1e90ff';
            case 8:
                return '#4c698b';
            case 9:
                return '#15324E';
            case 10:
                return '#F06800';
            case 16:
                return '#FFFFFF';
            case 17:
                return '#EBD300';
            case 11:
                return '#323232';
            case 12:
                return '#666666';
            case 13:
                return '#cccccc';
            case 14:
                return '#f8f8f8';
            case 15:
                return '#000003';
            // Used in player chat color
            case 19:
                return '#285FBD';
            case 18:
                return '#CF4449';
            case 20:
                return '#228103';
            case 21:
                return '#CF6B2E';
            case 22:
                return '#3D3D3D';
            case 23:
                return '#804640';
            case 24:
                return '#67717B';
            case 25:
                return '#946900';
            case 27:
                return '#72559E';
            case 28:
                return '#147A95';
            case 26:
                return '#8A8A8A';
            case 29:
                return '#CF6480';
            case 30:
                return '#48ff00';
            case 31:
                return '#cde7ca';
            case 32:
                return '#0bb000';
            case 33:
                return '#1A9118';
            case 34:
                return '#FFD8D9';
            case 35:
                return '#c00006';
            case 37:
                return '#46616E';
            case 38:
                return '#fffde1';
            case 36:
                return '#0967A6';
            case 39:
                return '#000000';
            case 40:
                return '#0A0A0A';
            case 41:
                return '#141414';
            case 42:
                return '#1F1F1F';
            case 43:
                return '#292929';
            case 44:
                return '#333333';
            case 45:
                return '#3D3D3D';
            case 46:
                return '#474747';
            case 47:
                return '#525252';
            case 48:
                return '#5C5C5C';
            case 49:
                return '#666666';
            case 50:
                return '#707070';
            case 51:
                return '#7A7A7A';
            case 52:
                return '#858585';
            case 53:
                return '#8F8F8F';
            case 54:
                return '#999999';
            case 55:
                return '#A3A3A3';
            case 56:
                return '#ADADAD';
            case 57:
                return '#B8B8B8';
            case 58:
                return '#C2C2C2';
            case 59:
                return '#CCCCCC';
            case 60:
                return '#D6D6D6';
            case 61:
                return '#E0E0E0';
            case 62:
                return '#EBEBEB';
            case 63:
                return '#F5F5F5';
            case 64:
                return '#FFFFFF';
            case 65:
                return '#ADADAD';
        }
    }
    GameColor.getColor = getColor;
    function getColorHexValue(color) {
        const myColor = getColor(color);
        return parseInt(myColor.slice(1), 16);
    }
    GameColor.getColorHexValue = getColorHexValue;
    function getPlayerBGDarkHash(playerColor) {
        switch(playerColor){
            case PlayerColor.Blue:
                return getColor(19);
            case PlayerColor.Red:
                return getColor(18);
            case PlayerColor.Orange:
                return getColor(21);
            case PlayerColor.Green:
                return getColor(20);
            case PlayerColor.Black:
                return getColor(22);
            case PlayerColor.Bronze:
                return getColor(23);
            case PlayerColor.Silver:
                return getColor(24);
            case PlayerColor.Gold:
                return getColor(25);
            case PlayerColor.MysticBlue:
                return getColor(28);
            case PlayerColor.White:
                return getColor(26);
            case PlayerColor.Purple:
                return getColor(27);
            case PlayerColor.Pink:
                return getColor(29);
            case PlayerColor.None:
                return getColor(16);
        }
    }
    GameColor.getPlayerBGDarkHash = getPlayerBGDarkHash;
    function getPlayerBGDarkHashForMobile(playerColor) {
        switch(playerColor){
            case PlayerColor.Blue:
                return '#2A73ED';
            case PlayerColor.Red:
                return '#E83239';
            case PlayerColor.Orange:
                return '#EC6D20';
            case PlayerColor.Green:
                return '#299E0E';
            case PlayerColor.Black:
                return '#707070';
            case PlayerColor.Bronze:
                return '#B25E55';
            case PlayerColor.Silver:
                return '#7E8893';
            case PlayerColor.Gold:
                return '#D69F2F';
            case PlayerColor.MysticBlue:
                return '#4FA8C4';
            case PlayerColor.White:
                return '#D3D3D3';
            case PlayerColor.Purple:
                return '#845CC5';
            case PlayerColor.Pink:
                return '#D66B87';
            case PlayerColor.None:
                return '#FFFFFF';
        }
    }
    GameColor.getPlayerBGDarkHashForMobile = getPlayerBGDarkHashForMobile;
    function getLighterGradientOfPlayerColor(playerColor) {
        switch(playerColor){
            case PlayerColor.Blue:
                return '#01A9FF';
            case PlayerColor.Red:
                return '#ED3437';
            case PlayerColor.Orange:
                return '#FF963B';
            case PlayerColor.Green:
                return '#7EC985';
            case PlayerColor.Bronze:
                return '#DD7B62';
            case PlayerColor.Silver:
                return '#D4D4D4';
            case PlayerColor.Gold:
                return '#EBD300';
            case PlayerColor.Black:
                return '#7C7D80';
            case PlayerColor.Purple:
                return '#D04DF7';
            case PlayerColor.MysticBlue:
                return '#0C7DBC';
            case PlayerColor.White:
                return '#CFEEF2';
            case PlayerColor.Pink:
                return 'pink';
            case PlayerColor.None:
                return '#000000';
        }
    }
    GameColor.getLighterGradientOfPlayerColor = getLighterGradientOfPlayerColor;
    function getDarkerGradientOfPlayerColor(playerColor) {
        switch(playerColor){
            case PlayerColor.Blue:
                return '#1216CE';
            case PlayerColor.Red:
                return '#B90101';
            case PlayerColor.Orange:
                return '#DE6800';
            case PlayerColor.Green:
                return '#18A101';
            case PlayerColor.Bronze:
                return '#9B3918';
            case PlayerColor.Silver:
                return '#686868';
            case PlayerColor.Gold:
                return '#F37B24';
            case PlayerColor.Black:
                return '#464547';
            case PlayerColor.Purple:
                return '#7553AD';
            case PlayerColor.MysticBlue:
                return '#53C1FF';
            case PlayerColor.White:
                return '#88ADAC';
            case PlayerColor.Pink:
                return 'pink';
            case PlayerColor.None:
                return '#000000';
        }
    }
    GameColor.getDarkerGradientOfPlayerColor = getDarkerGradientOfPlayerColor;
})(GameColor || (GameColor = {}));
export var GameColor;
